<div class="modal-container">

  <div class="modal-header existing-session-header">
    <span class="modal-title">{{'Existing Mobile Van Session' | translate}}</span>

    <i class="fa fa-times fa-lg existing-session-close"
       (click)="activeModal.dismiss('x')"
       title="close"></i>
  </div>

  <div class="modal-body">
    <p class="msg-title">{{'Open Roadside assistance / Mobile Van session for this vehicle'|translate}}</p>
    <p class="msg-sub">{{'Do you wish to Resume or Start a new session?'|translate}}</p>
  </div>

  <div class="modal-footer">
    <div class="button-group">
      <button type="button" class="btn btn-primary" (click)="continueWithExistingSession(content); activeModal.close({action: 'RESUME', contentTemplate: content})">
        {{'Yes - Resume session' | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="activeModal.close('START_NEW')">
        {{'No - Start new session' | translate}}
      </button>
    </div>
  </div>

</div>
<ng-template #mobileVanModal let-modal>
  <div
    class="dialog widget widget-content corner-all front dialog-buttons draggable mobilevan-dialog"
    style="height:auto; width:640px; display:block;"
  >
    <div class="dialog-titlebar widget-header corner-all">
      <i class="fa fa-times fa-lg close2" (click)="modal.dismiss('close')" title="close"></i>
    </div>

    <div class="dialog-content mobilevan-msg" style="text-align:center; font-weight:600;">
      {{ 'Is this still a roadside assistance/ mobile van session?' | translate }}
    </div>

  <div class="dialog-buttonpane">
  <div class="mobilevan-btn-row">
    <button
    class="mobilevan-btn"
    aria-hidden="false"
    (click)="modal.close(true)"><span>{{'No'|translate}}</span></button>
    <button  class="mobilevan-btn"
    aria-hidden="false" (click)="modal.close(false)"><span>{{'Yes'|translate}}</span></button>
  </div>
</div>

  </div>
</ng-template>
<ng-template #noRVCMsgDesc let-modal>
  <div class="container version">
    <div class="row popup-header" style="margin-top: 0%;">
      <div class="pull-left">{{'Information'|translate}}</div>
      <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true" *ngIf="!isButtonEnabled"
                                                            (click)="modal.dismiss('noRVCMsgDesc')"></i></div>
    </div>
    <div>
      <label class='msg-body'>
        <p class="norvg-msg">{{'norvc_req_description_msg' | translate}}</p>
      </label>
    </div>
    <hr class="hr-line1">
    <div class="popup-footer">
      <button type="button" class="btn btn-primary mr-3 pull-right confirm" name="confirm"  [disabled]="isButtonEnabled"
              (click)="modal.dismiss('noRVCMsgDesc')">{{'Confirm'|translate}}</button>
    </div>
  </div>
</ng-template>
<ng-template #content let-modal>
  <div  class="modal-content">
    <div class="modal-header">
      <div class="modal-title mng-qualifier-title mng-qualifier-header-popup" id="exampleModalLongTitle">
        {{'Information'|translate}}</div>
      <i class="fa fa-times mng-qualifier-close-btn" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="deleteContent info-s">
      <p>{{'Diagnosis and Repair info'|translate}}</p>
    </div>
    <div class="modal-footer">

      <button type="button" class="buttons" (click)="modal.dismiss('Cross click')">{{'Continue'|translate}}</button>

    </div>
  </div>
</ng-template>



